<template>
  <section class="container">

    <div class="row mt-5">
      <div class="col-12">
        <h2>แบบทดสอบ</h2>
      </div>
    </div>

    <div class="row" v-if="_.size(this.examinations) > 0">
      <div class="col-sm-6" v-for="item in examinations" :key="item.id">

        <div class="card  border-primary mb-3">
          <div class="card-body">
            <h5 class="card-title text-bold">{{ item.questionnaire.name }}</h5>
            <p class="card-text">

              <template
                v-if="_.size(item.examination) > 0 && _.size(item.examination.examination_details) > 0 && checkHasDone(item.examination.examination_details)">

                <div v-if="item.status === 1">
                  <span class="text-success"><i class="fas fa-check"></i> ทำเสร็จแล้ว</span>
                  <br>
                  <span><i class="far fa-flag"></i> คะแนนที่ทำได้: {{ scoreExamination(item.examination.examination_details) }}</span>
                  <br>
                  <span><i class="far fa-calendar-alt"></i> วันที่ทำเสร็จ: {{ item.completed_at | prettyOnlyDate }}</span>
                  <div class="mt-3">
                    <button class="btn btn-warning" @click="openExaminationModal(item.examination.id)">คำถามที่ตอบผิด</button>
                  </div>
                </div>

                <span class="text-warning" v-if="item.status === 0">
                  <i class="fas fa-tasks"></i> ยังทำไม่เสร็จ
                </span>

              </template>

              <template v-else>
                <span class="text-warning"><i class="far fa-sticky-note"></i> ยังไม่ได้เริ่มทำแบบทดสอบ</span>
              </template>
            </p>

            <!--   ถ้ายังทำไม่เสร็จ และ ยังไม่ได้เริ่มทำแบบทดสอบซักข้อ  -->
            <router-link
              v-if="item.status === 0 ||
            ( _.size(item.examination) > 0 && _.size(item.examination.examination_details) > 0  && !checkHasDone(item.examination.examination_details))"
                         class="btn btn-primary"
                         tag="button"
                         :to="{ name: 'Professional Questionnaire Test', params: {id: item.id} }"> ทำแบบทดสอบ
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col-12">
        <blockquote class="blockquote">
          <p class="mb-0"><i class="fas fa-exclamation-circle"></i> {{ this.message }}</p>
        </blockquote>
      </div>
    </div>

    <examination-modal ref="examinationModal"></examination-modal>

  </section>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import ExaminationModal from './components/ExaminationModal'

export default {
  name: 'ExaminationProfile',
  data () {
    return {
      show: false,
      message: '',
      examinations: []
    }
  },
  components: {
    ExaminationModal
  },
  methods: {
    openExaminationModal (examId) {
      this.$refs.examinationModal.openModal(examId)
    },
    scoreExamination (examinationDetails) {
      try {
        let score = _.sumBy(examinationDetails, function (o) { return o.is_correct })
        let maxScore = _.size(examinationDetails)

        return score + ' / ' + maxScore + ' คะแนน'
      } catch (err) {
      }
    },
    checkHasDone (examinationDetails) {
      try {
        let hasDone = _.every(examinationDetails, ['question_answer_id', null])
        if (hasDone) {
          return false
        } else {
          return true
        }
      } catch (err) {
        this.$swal({ text: err, type: 'error' })
      }
    },
    async fetchExaminations () {
      this.$swal.showLoading()
      this.message = ''
      let { data } = await axios.get('professional/examinations/' + this.$route.params.id)
      if (!data.error) {
        this.examinations = JSON.parse(JSON.stringify(data.examinations))
      } else {
        this.message = data.message
        this.$swal({ text: data.message, type: 'error' })
      }
      this.$swal.close()
    },
    showExamination () {
      console.log(123)
    }
  },
  created () {
    this.fetchExaminations()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/professional/ExaminationProfile.vue